module.exports = __webpack_public_path__ + "static/media/primary-6.c3f8b082.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primary-6.jpg
// module id = 159
// module chunks = 0